import React from "react";
import style from "./Modalities.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { signedLockedAccess } from "../../../../utils";

export const MultiSelectSectionViewMode = ({
  label,
  sectionData,
  listResp,
  assessmentDetails,
  hideButtons,
  onEdit,
}) => (
  <div className={style.viewMode_container}>
    <div className="d-flex justify-content-between">
      <div className={`${style.lab_container} d-flex col-11 p-0`}>
        <label className="col-5 p-0">{label}</label>
        <div className="col-6 p-0">
          {sectionData?.length > 0 &&
            sectionData.map((e) => {
              const match = listResp?.find((l) => e === l.key);
              return (
                <div className="font-weight-bold" key={e}>
                  {match?.value ?? ""}
                </div>
              );
            })}
        </div>
      </div>

      <div>
        {signedLockedAccess(assessmentDetails?.assessmentStage) && hideButtons && (
          <div className={style.tab_edit} onClick={onEdit}>
            <img src={editIcon} alt="icon" className={style.e_icon_space} />
            Edit
          </div>
        )}
      </div>
    </div>
  </div>
);